import { createSelector } from "@reduxjs/toolkit";
import { selectSelfTextFormat } from "./self.selector";


export const getMarkupTextFormat = createSelector(
    selectSelfTextFormat,
    (state) => state
)